import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { MotionConfig } from 'motion/react'
import { AuthGate } from '@/auth/AuthGate'
import { TooltipProvider } from '@/components/ui/Tooltip'
import { queryClient } from '@/lib/queryClient'
import { spring } from '@/lib/motion'
import { App } from './App'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root element missing')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Honour the OS "reduce motion" setting: transforms/layout animations are skipped. */}
      <MotionConfig reducedMotion="user" transition={spring.smooth}>
        <TooltipProvider delayDuration={400} skipDelayDuration={200}>
          <AuthGate>
            <App />
          </AuthGate>
        </TooltipProvider>
      </MotionConfig>
    </QueryClientProvider>
  </StrictMode>,
)
